export default __webpack_public_path__ + "static/brand_text-f98e78019ab085a75d947e2b6c191259.png";